/**
 * API Service containing stateless network utility functions
 */
export const Api = {
	/**
	 * Fetch autocomplete suggestions
	 */
	autoCompleteSuggestion(inputValue) {
		return new Promise((resolve, reject) => {
			const xhr = new XMLHttpRequest();
			xhr.open('GET', `/api/autosuggest?search=${inputValue}`, true);
			xhr.onload = function () {
				if (xhr.status === 200) {
					const data = JSON.parse(xhr.responseText);
					resolve(data);
				} else {
					reject(xhr.statusText);
				}
			};
			xhr.onerror = function () {
				reject(xhr.statusText);
			};
			xhr.send();
		});
	},

	/**
	 * Fetch company information
	 */
	getCompanyInfo(symbol) {
		return new Promise((resolve, reject) => {
			const xhr = new XMLHttpRequest();
			xhr.open('GET', `/api/company/${symbol}`, true);
			xhr.onload = function () {
				if (xhr.status === 200) {
					const data = JSON.parse(xhr.responseText);
					resolve(data);
				} else {
					reject(xhr.statusText);
				}
			};
			xhr.onerror = function () {
				reject(xhr.statusText);
			};
			xhr.send();
		});
	}
};

window.Api = Api;
